import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthProvider";
import { ToastContainer } from "react-toastify";
import "./i18n";
import { LanguageProvider } from "./config";
import { ThemeContextProvider } from "./context/ThemeContext";
const root: ReactDOM.Root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AuthProvider>
    <LanguageProvider>
      <App />
      <ToastContainer />
    </LanguageProvider>
  </AuthProvider>
);
